import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TestingToolkitService } from '../../services/testing-toolkit.service';
import { environment } from '../../../environments/environment';
import {
    ButtonDirective,
    CardModule,
    FormModule,
    BadgeModule,
    TooltipModule
} from '@coreui/angular-pro';
import { IconDirective } from '@coreui/icons-angular';

@Component({
    selector: 'app-testing-toolkit',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ButtonDirective,
        CardModule,
        FormModule,
        BadgeModule,
        TooltipModule,
        IconDirective
    ],
    templateUrl: './testing-toolkit.component.html',
    styleUrls: ['./testing-toolkit.component.scss']
})
export class TestingToolkitComponent implements OnInit, OnDestroy {
    isExpanded = false;
    testDateInput = '';
    isTestDateActive = false;
    currentEnvironment = '';

    private subscription: Subscription | null = null;

    constructor(private testingToolkit: TestingToolkitService) {
        // Determine current environment name
        if (environment.production) {
            this.currentEnvironment = 'Production';
        } else if (environment.baseUrl.includes('sandboxapi')) {
            this.currentEnvironment = 'QA';
        } else if (environment.baseUrl.includes('devtunnels')) {
            this.currentEnvironment = 'Tunnel';
        } else {
            this.currentEnvironment = 'Development';
        }
    }

    ngOnInit(): void {
        this.subscription = this.testingToolkit.testDate$.subscribe(date => {
            this.isTestDateActive = date !== null;
            this.testDateInput = this.testingToolkit.formatDateForInput(date);
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    togglePanel(): void {
        this.isExpanded = !this.isExpanded;
    }

    onDateChange(): void {
        const date = this.testingToolkit.parseDateFromInput(this.testDateInput);
        this.testingToolkit.setTestDate(date);
    }

    clearDate(): void {
        this.testDateInput = '';
        this.testingToolkit.clearTestDate();
    }

    setToToday(): void {
        const today = new Date();
        this.testDateInput = this.testingToolkit.formatDateForInput(today);
        this.testingToolkit.setTestDate(today);
    }
}
